import { NumberField } from '@base-ui/react/number-field';
import UntitledIcon from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';
import InputGroup, { type InputGroupRawInput } from '../InputGroup/InputGroup';
import type { InputSizeVariant } from './RawInput';

export interface IncrementableNumberInputProps extends Omit<
  InputGroupRawInput,
  'value' | 'onChange'
> {
  sizeVariant?: InputSizeVariant;
  wrapperClassName?: string;
  value: number | null;
  onChange?: (quantity: number | null) => void;
  increment?: number;
  min?: number;
  max?: number;
}

const IncrementableNumberInput: FC<IncrementableNumberInputProps> = (props) => {
  const {
    sizeVariant,
    wrapperClassName,
    value,
    increment = 1,
    min,
    max,
    onChange,
    disabled,
    inputClassName,
    ...rest
  } = props;

  return (
    <NumberField.Root
      value={value}
      onValueChange={(newValue) => onChange?.(newValue)}
      min={min}
      max={max}
      step={increment}
      disabled={disabled}
    >
      <InputGroup className={wrapperClassName} sizeVariant={sizeVariant}>
        <NumberField.Decrement
          render={<InputGroup.Button variant={'secondary'} />}
          aria-label={`Decrement by ${increment}`}
        >
          <UntitledIcon name="minus.3" className="h-4 w-4" />
        </NumberField.Decrement>

        <NumberField.Input
          render={
            <InputGroup.RawInput
              {...rest}
              inputClassName={clstx('text-center', inputClassName)}
            />
          }
        />

        <NumberField.Increment
          render={<InputGroup.Button variant={'secondary'} />}
          aria-label={`Increment by ${increment}`}
        >
          <UntitledIcon name="plus.3" className="h-4 w-4" />
        </NumberField.Increment>
      </InputGroup>
    </NumberField.Root>
  );
};

export default IncrementableNumberInput;
